import { IGamesStore } from '../store';

import api, { request } from '../../../../api';
import { IErrorsStore } from '../../../errors/store';
import { IStore } from '../../../index';

export const swapPlayersSeats = async (
  state: IStore,
  groupId: number,
  groupGame1Id: number,
  groupGame1Seat: number,
  groupGame2Id: number,
  groupGame2Seat: number
): Promise<{ games?: IGamesStore; errors?: IErrorsStore }> => {
  const response1 = await request.patch(`${api.groupGame(groupId, groupGame1Id)}`, {
    seat: groupGame2Seat
  });

  if (response1.error) {
    return { errors: { games: { msg: 'Error updating the game.' } } };
  }

  const response2 = await request.patch(`${api.groupGame(groupId, groupGame2Id)}`, {
    seat: groupGame1Seat
  });

  if (response2.error) {
    return { errors: { games: { msg: 'Error updating the game.' } } };
  }

  return state;
};
